import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  statusHeaderRoot: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.spacing(3),
    width: '100%',
  },
  offerLinkItems: {
    display: 'flex',
  },
  offerLinkText: {
    fontSize: '14px',
  },
  offerLinkRoot: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  updateButtonContainer: {},
  disabledEdit: {
    opacity: '39%',
  },
  extendOfferExpiry: {
    fontSize: '14px !important',
    height: theme.spacing(2.5),
    minHeight: `${theme.spacing(2.5)} !important`,
  },
  fullWidthStatusBar: {
    width: '100%',
  },
  fullWidthStatusBarWithExpiration: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  expirationContainer: {
    display: 'flex',
  },
  greyedOut: {
    color: '#6A777A',
    fontSize: '11px',
    fontWeight: 500,
  },
  statusText: {
    fontSize: '14px',
    fontWeight: 400,
  },
}))
